import { checkRefundGenieAccess } from "@/requests/refundGenieRequest";
import { leitenRequest } from "@helium10/re-core";
import { create } from "zustand";

interface IRefundGenieStore {
  permission: {
    reportEnable: boolean;
    apiTokenBind: boolean;
  };
}

export const useRefundGenieStore = create<IRefundGenieStore>(() => ({
  permission: {
    reportEnable: false,
    apiTokenBind: false,
  },
}));

export const useRefundGenieRequest = leitenRequest(
  useRefundGenieStore,
  "permission",
  async (_: void) => {
    const result = await checkRefundGenieAccess();
    return result.data;
  },
  {
    initialStatus: "init",
  },
);
